import { nevisignFetch } from "@nevisign/reader-core";
import type { ContractWorkflowStateDTO } from "@platform/shared-types";

export async function actOnPlatformSignature(
  apiBase: string,
  contractId: string,
  processId: string,
  input: {
    action: "seen" | "sign" | "reject" | "comment";
    comment?: string;
    rejectionReason?: string;
    reauthToken?: string;
  },
): Promise<ContractWorkflowStateDTO> {
  const res = await nevisignFetch(
    apiBase,
    `/contracts/${encodeURIComponent(contractId)}/signatures/${encodeURIComponent(processId)}/act`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(input),
    },
  );
  const text = await res.text();
  if (!text.trim()) {
    throw new Error("پاسخ خالی از سرور");
  }
  let data: { workflow?: ContractWorkflowStateDTO; error?: string; message?: string };
  try {
    data = JSON.parse(text) as typeof data;
  } catch {
    throw new Error("پاسخ سرور قابل خواندن نبود");
  }
  if (!res.ok) {
    throw new Error(
      data.message || data.error || `خطای سرور (${res.status})`,
    );
  }
  if (!data.workflow) {
    throw new Error("پاسخ سرور ناقص بود");
  }
  return data.workflow;
}

export async function requestPlatformSignReauth(
  apiBase: string,
  contractId: string,
  processId: string,
): Promise<{ debugCode?: string }> {
  const res = await nevisignFetch(
    apiBase,
    `/contracts/${encodeURIComponent(contractId)}/signatures/${encodeURIComponent(processId)}/reauth/request`,
    { method: "POST" },
  );
  const text = await res.text();
  if (!text.trim()) return {};
  try {
    return JSON.parse(text) as { debugCode?: string };
  } catch {
    return {};
  }
}

export async function verifyPlatformSignReauth(
  apiBase: string,
  contractId: string,
  processId: string,
  code: string,
): Promise<{ reauthToken?: string }> {
  const res = await nevisignFetch(
    apiBase,
    `/contracts/${encodeURIComponent(contractId)}/signatures/${encodeURIComponent(processId)}/reauth/verify`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ code }),
    },
  );
  const text = await res.text();
  if (!res.ok) {
    let msg = "تأیید کد ناموفق بود";
    try {
      const err = JSON.parse(text) as { error?: string; message?: string };
      msg = err.message || err.error || msg;
    } catch {
      /* ignore */
    }
    throw new Error(msg);
  }
  return JSON.parse(text) as { reauthToken?: string };
}
